const paths = {
  home: 'm3 10 9-7 9 7v11h-6v-7H9v7H3Z',
  logout: 'M9 4H4v16h5m6-16 6 6-6 6m-7-6h13',
  refresh: 'M20 7a9 9 0 1 0 1 8M20 3v5h-5',
  download: 'M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5',
  plus: 'M12 5v14M5 12h14',
  back: 'm10 5-7 7 7 7M3 12h18',
  edit: 'm15 4 5 5M4 20l5-1L21 7a2 2 0 0 0-5-5L4 14Z',
  trash: 'M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7',
  income: 'M12 3v18m-7-7 7 7 7-7',
  outcome: 'M12 21V3m-7 7 7-7 7 7',
};

export default function FinanceIcon({ name }) {
  return <svg className="finance-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d={paths[name]} /></svg>;
}
